<template>
  <v-container>
    <DepositsSidebar
      :deposits="[]"
      :show-back="true"
    />

    <v-card
      variant="outlined"
      class="mb-4"
    >
      <v-card-title>{{ deposit_name || deposit_id }}</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col
            cols="12"
            sm="auto"
            class="pr-6"
          >
            <div class="text-caption text-medium-emphasis">
              Deposit ID
            </div>
            <div>{{ deposit_id }}</div>
          </v-col>
          <v-col
            cols="12"
            sm="auto"
            class="pr-6"
          >
            <div class="text-caption text-medium-emphasis">
              Created
            </div>
            <div>{{ created_date ? formatDate(created_date) : '—' }}</div>
          </v-col>
          <v-col
            cols="12"
            sm="auto"
            class="pr-6"
          >
            <div class="text-caption text-medium-emphasis">
              Files uploaded
            </div>
            <div>{{ fileCount !== null ? fileCount : '—' }}</div>
          </v-col>
          <v-col
            cols="12"
            sm="auto"
          >
            <div class="text-caption text-medium-emphasis">
              Total size
            </div>
            <div>{{ totalSize !== null ? formatSize(totalSize) : '—' }}</div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <DepositFileList @stats="onStats" />
    <UploadFiles v-if="ownsActiveDeposit" />
    <AdminUnownedDeposit v-else />
    <v-btn
      v-if="$routerHistory.hasPrevious() || $route.query.admin_user"
      :to="backRoute"
      :class="['ml-4', { 'mt-4': !ownsActiveDeposit }]"
    >
      GO BACK
    </v-btn>
  </v-container>
</template>

<script>
import { Auth } from '@/utils/amplify-compat';
import { formatDate } from '@/utils/formatDate';
import { filesize } from 'filesize';
import DepositFileList from '@/components/DepositFileList.vue';
import UploadFiles from '@/components/UploadFiles.vue';
import DepositsSidebar from '@/components/DepositsSidebar.vue';
import AdminUnownedDeposit from '@/components/AdminUnownedDeposit.vue';

export default {
  components: {
    DepositFileList,
    UploadFiles,
    DepositsSidebar,
    AdminUnownedDeposit
  },
  props: {
    depositor:    { type: String, default: '' },
    deposit_id:   { type: String, default: '' },
    deposit_name: { type: String, default: '' },
    created_date: { type: String, default: '' },
  },
  data: () => ({
    dialog: false,
    myIdentityId: '',
    fileCount: null,
    totalSize: null,
  }),
  computed: {
    ownsActiveDeposit() {
      return this.depositor === this.myIdentityId;
    },
    backRoute() {
      if (this.$route.query.admin_user) {
        const q = { restore_user: this.$route.query.admin_user }
        if (this.$route.query.admin_user_name) q.admin_user_name = this.$route.query.admin_user_name
        if (this.$route.query.admin_search) q.admin_search = this.$route.query.admin_search
        if (this.$route.query.admin_page) q.admin_page = this.$route.query.admin_page
        return { path: '/admin', query: q }
      }
      return { path: this.$routerHistory.previous().path }
    },
  },
  created() {
    Auth.currentCredentials().then((user) => {
      this.myIdentityId = user.identityId;
    });
  },
  methods: {
    formatDate,
    formatSize(bytes) {
      return filesize(bytes);
    },
    onStats({ count, totalSize }) {
      this.fileCount = count;
      this.totalSize = totalSize;
    },
    cancelUpload() {
      this.dialog = false;
    },
  },
}
</script>

<style>
.logo {
  max-height: 80px;
}
</style>
